import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../app/hooks";
import { getParamAsInt } from "../../../app/utils";
import AlertMessage, { AlertLevel } from "../../../components/AlertMessage";
import { ClassLinkOrCleverIconWithTooltip } from "../../../components/ClassLinkOrCleverIcon";
import { Loading } from "../../../components/Loading";
import { AdminEditCourseViewModel, useLazyGetEditCourseInfoQuery } from "../coursesApiSlice";
import CourseTeachersSection from "./CourseTeachersSection";
import CourseStudentsSection from "./CourseStudentsSection";
import CourseInformationSection from "./CourseInformationSection";

export default function EditCourseByAdmin() {
	const [queryParams] = useSearchParams();
	const courseId = getParamAsInt(queryParams, "courseId");

	const { config } = useAppSelector((state) => state.site);

	const [errorMessage, setErrorMessage] = useState("");
	const [showOutsideIcon, setShowOutsideIcon] = useState(false);

	const [courseInfo, setCourseInfo] = useState<AdminEditCourseViewModel>();

	const [getCourseInfo, getCourseInfoResult] = useLazyGetEditCourseInfoQuery();

	useEffect(() => {
		if (courseId) {
			getCourseInfo(courseId)
				.unwrap()
				.then((payload) => {
					setCourseInfo(payload);
				});
		}
	}, []);

	useEffect(() => {
		setShowOutsideIcon(!!courseInfo?.classLinkID || !!courseInfo?.cleverID);
	}, [courseInfo]);

	const tooltipContent = courseInfo?.cleverID
		? "This course has a Clever account"
		: courseInfo?.classLinkID
			? "This course has a ClassLink account"
			: undefined;

	return (
		<section>
			<h1>Manage Course</h1>
			<Loading loading={getCourseInfoResult.isLoading} />
			{courseInfo && courseId && (
				<section>
					<div className="flex mt-6 gap-x-3 items-center">
						{showOutsideIcon && !config?.isUtahComposeSite && (
							<ClassLinkOrCleverIconWithTooltip
								isClassLinkEntity={!!courseInfo.classLinkID}
								isCleverEntity={!!courseInfo.cleverID}
								iconClasses="size-10"
								tooltipId="outside-site-icon-tooltip"
								tooltipContent={tooltipContent}
							/>
						)}
						<h2>{courseInfo.editModel.name}</h2>
					</div>
					<AlertMessage
						className="mt-4 text-sm"
						type={AlertLevel.Error}
						message={errorMessage}
						showIcon={true}
					/>
					<CourseInformationSection
						courseInfo={courseInfo}
						addingNew={false}
						setErrorMessage={setErrorMessage}
						setCourseInfo={setCourseInfo}
					/>
					<CourseTeachersSection teachers={courseInfo.proctors} />
					<CourseStudentsSection students={courseInfo.students} />
				</section>
			)}
		</section>
	);
}
